import { createReducer } from '../../../../utils/ReduxUtils';
import * as types from '../../actionTypes';

const initialState = false;

const show = () => true;
const hide = () => false;

export default createReducer(initialState, {
  [types.SHOW_PASSWORD_MODAL]: show,
  [types.HIDE_PASSWORD_MODAL]: hide,
}, [
  {
    matcher: ({ type, meta }) =>
      (type === types.PATCH_USER_SUCCESS || type === types.PATCH_USER_FAILURE) && meta?.field === 'password',
    reducer: hide,
  }
]);
